const colorCode = {
    "Java": "Red",
    "C++": "DeepPink",
    "C#": "DarkGreen",
    "JavaScript": "Yellow",
    "Python": "SteelBlue"
}

export {colorCode}